import {
  creativeDataDirections,
  creativeDataDurationsUnit,
  creativeDataFormat,
  creativeDataRatios,
  creativeDataSource,
  creativeDataType,
  creativeSizeUnit,
} from '@pt/views/pt-entry/creative-assets/media/config'
import { format, subDays } from 'date-fns'
import i18n from '@/lang'

export const filterSchemaConfig = {
  source: {
    prop: 'source',
    component: 'select',
    field: {
      multiple: true,
      'collapse-tags': true,
      clearable: true,
      options: creativeDataSource,
      checkable: true,
      placeholder: i18n.t('resourceManager.filter.source'),
    },
  },
  formats: {
    prop: 'formats',
    component: 'select-group',
    field: {
      multiple: true,
      checkable: true,
      'collapse-tags': true,
      clearable: true,
      options: creativeDataFormat,
      placeholder: i18n.t('resourceManager.filter.format'),
    },
  },
  types: {
    prop: 'types',
    class: 'lang-en-select',
    component: 'select',
    field: {
      clearable: true,
      options: creativeDataType,
      'collapse-tags': true,
      multiple: true,
      checkable: true,
      placeholder: i18n.t('resourceManager.filter.type'),
    },
  },
  created_time: {
    prop: 'created_time',
    component: 'date-picker',
    field: {
      clearable: false,
      placeholder: i18n.t('resourceManager.filter.type'),
      type: 'daterange',
      'unlink-panels': true,
      format: 'yyyy/MM/dd',
      'value-format': 'yyyy-MM-dd',
      'picker-options': {
        shortcuts: [
          {
            text: i18n.t('resourceManager.filter.today'),
            onClick(picker: any) {
              picker.$emit('pick', [
                format(new Date(), 'YYYY-MM-DD'),
                format(new Date(), 'YYYY-MM-DD'),
              ])
            },
          },
          {
            text: i18n.t('resourceManager.filter.week'),
            onClick(picker: any) {
              picker.$emit('pick', [
                format(subDays(new Date(), 7), 'YYYY-MM-DD'),
                format(new Date(), 'YYYY-MM-DD'),
              ])
            },
          },
        ],
      },
    },
  },
  updated_time: {
    prop: 'updated_time',
    component: 'date-picker',
    field: {
      clearable: false,
      placeholder: i18n.t('resourceManager.filter.updateTime'),
      type: 'daterange',
      'unlink-panels': true,
      format: 'yyyy/MM/dd',
      'value-format': 'yyyy-MM-dd',
      'picker-options': {
        shortcuts: [
          {
            text: i18n.t('resourceManager.filter.today'),
            onClick(picker: any) {
              picker.$emit('pick', [
                format(new Date(), 'YYYY-MM-DD'),
                format(new Date(), 'YYYY-MM-DD'),
              ])
            },
          },
          {
            text: i18n.t('resourceManager.filter.week'),
            onClick(picker: any) {
              picker.$emit('pick', [
                format(subDays(new Date(), 7), 'YYYY-MM-DD'),
                format(new Date(), 'YYYY-MM-DD'),
              ])
            },
          },
        ],
      },
    },
  },
  directions: {
    prop: 'directions',
    component: 'select',
    field: {
      multiple: true,
      checkable: true,
      'collapse-tags': true,
      clearable: true,
      options: creativeDataDirections,
      placeholder: i18n.t('resourceManager.filter.direction'),
    },
  },
  ratios: {
    prop: 'ratios',
    component: 'select',
    field: {
      multiple: true,
      checkable: true,
      'collapse-tags': true,
      clearable: true,
      options: creativeDataRatios,
      placeholder: i18n.t('resourceManager.filter.proportion'),
    },
  },
  width_min: {
    prop: 'width_min',
    component: 'input-number',
    field: {
      controls: false,
      step: 1,
      'step-strictly': true,
      min: 0,
      max: 999999,
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.min'),
    },
  },
  width_max: {
    prop: 'width_max',
    component: 'input-number',
    field: {
      controls: false,
      step: 1,
      'step-strictly': true,
      min: 0,
      max: 999999,
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.max'),
    },
  },
  height_min: {
    prop: 'height_min',
    component: 'input-number',
    field: {
      controls: false,
      step: 1,
      'step-strictly': true,
      min: 0,
      max: 999999,
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.min'),
    },
  },
  height_max: {
    prop: 'height_max',
    component: 'input-number',
    field: {
      controls: false,
      step: 1,
      'step-strictly': true,
      min: 0,
      max: 999999,
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.max'),
    },
  },
  bitrate_min: {
    prop: 'bitrate_min',
    component: 'input-number',
    field: {
      controls: false,
      step: 1,
      'step-strictly': true,
      min: 0,
      max: 999999,
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.min'),
    },
  },
  bitrate_max: {
    prop: 'bitrate_max',
    component: 'input-number',
    field: {
      controls: false,
      step: 1,
      'step-strictly': true,
      min: 0,
      max: 999999,
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.max'),
    },
  },
  size_min: {
    prop: 'size_min',
    component: 'input-number',
    field: {
      controls: false,
      step: 1,
      'step-strictly': true,
      min: 0,
      max: 999999,
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.min'),
    },
  },
  size_max: {
    prop: 'size_max',
    component: 'input-number',
    field: {
      controls: false,
      step: 1,
      'step-strictly': true,
      min: 0,
      max: 999999,
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.max'),
    },
  },
  duration_min: {
    prop: 'duration_min',
    component: 'input-number',
    field: {
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.min'),
      controls: false,
      style: 'width: 86px;',
      step: 1,
      min: 0,
      max: 999999,
      'step-strictly': true,
    },
  },
  duration_max: {
    prop: 'duration_max',
    component: 'input-number',
    field: {
      clearable: true,
      placeholder: i18n.t('resourceManager.filter.max'),
      controls: false,
      style: 'width: 86px;',
      step: 1,
      min: 0,
      max: 999999,
      'step-strictly': true,
    },
  },
  duration_unit: {
    prop: 'duration_unit',
    component: 'select',
    field: {
      options: creativeDataDurationsUnit,
      placeholder: '单位',
      style: 'width: 80px;',
    },
  },
  size_unit: {
    prop: 'size_unit',
    component: 'select',
    field: {
      options: creativeSizeUnit,
      placeholder: '单位',
      style: 'width: 80px;',
    },
  },
}
